import axios from "axios";
import server from "../services/Connection/backEndLink";
import dashboardConfig from "./Connection/dashboardConfig";
import v3Config from "./Connection/v3Config";
// import { confirmCloseAlert } from "../functions/alerts"
import { status } from "../components/Status";
import { getValueCookie } from "./cookieService";
import { closeSession } from "../functions/closeSession";
// Alerts
import Swal from "sweetalert2";

// URL for http requests
const baseURLAuth = server.url;
// const baseURLAuth = "http://localhost:4800";

// Limit time for http requests — 30 s is generous; the Express timeout guard
// fires at 35 s, so axios will always surface the error to the user first.
const REQUEST_TIMEOUT = 30000;

// ── Connection error toast ────────────────────────────────────────────────────
// Deduplication: show at most one toast every 8 seconds to avoid spam when
// multiple requests fail at the same time (e.g. dashboard on reconnect).
let _lastWorkerToastAt = 0;

function showWorkerToast(isWorkerOffline, httpStatus, timeoutCode) {
  const now = Date.now();
  if (now - _lastWorkerToastAt < 8000) return; // debounce
  _lastWorkerToastAt = now;

  let title, text, icon;

  if (isWorkerOffline) {
    title = '⚙️ Reconectando con SAGE';
    text  = 'El servicio MAS90/SAGE se está reconectando. Espera unos segundos e intenta de nuevo.';
    icon  = 'info';
  } else if (timeoutCode === 'TIMEOUT') {
    title = '⏱ La petición tardó demasiado';
    text  = 'El servidor no respondió a tiempo. El worker puede estar reconectándose — intenta de nuevo.';
    icon  = 'warning';
  } else if (timeoutCode === 'NETWORK') {
    title = '🔌 Sin conexión al servidor';
    text  = 'No se pudo conectar. Verifica tu internet o espera un momento.';
    icon  = 'error';
  } else if (httpStatus) {
    title = 'Error del servidor (' + httpStatus + ')';
    text  = 'El servidor respondió con error. Intenta de nuevo en unos segundos.';
    icon  = 'error';
  } else {
    return; // nothing actionable
  }

  Swal.fire({
    toast:            true,
    position:         'top-end',
    icon:             icon,
    title:            title,
    text:             text,
    showConfirmButton: false,
    timer:            6000,
    timerProgressBar: true,
  });
}

export const getInformationNoData = async (route) => {
    const URL = baseURLAuth + route;
    var responseBack = {
        data: [],
        status: status.Fail
    }
    await axios.get(URL).then(
        response => {
            responseBack = response.data
        }
    ).catch(error => {
        responseBack = { status: status.ServerFail, response: [] };
        // confirmCloseAlert('incorrect', 'Error in the Server Response: ' + error)
    })

    return responseBack;
}

export const GetWithInformation = async (route, data) => {
    const URL = baseURLAuth + route;
    var responseBack = {
        data: [],
        status: status.Fail
    }
    await axios.get(URL, { params: data }).then(
        response => {
            responseBack = response.data
        }
    ).catch(error => {
        responseBack = { status: status.ServerFail, response: [] };
        // confirmCloseAlert('incorrect', 'Error in the Server Response: ' + error)
    })

    return responseBack;
}

// export const getInformationWithData = async (route, data) => {
//     const URL = baseURLAuth + route;
//     var responseBack = {
//         data: [],
//         status: status.Fail
//     }

//     if (getValueCookie('userName')) {
//         await axios.post(URL, { data: data }).then(
//             response => {
//                 responseBack = response.data
//             }
//         ).catch(error => {
//             // confirmCloseAlert('incorrect', 'Error in the Server Response: ' + error)
//         })
//     } else {
//         closeSession()
//         window.location.reload()
//     }

//     return responseBack
// }

// Make http request to elixir app
export const getElixirApiData = async (route, data) => {
    // Validate session
    if (!getValueCookie('userName')) {
        // Remove cookies
        closeSession();

        // Redirect to login V2
        window.location.assign("/login");

        // Importante: rechazamos la promesa para que el caller lo pueda manejar si quiere
        throw new Error('Invalid user session');
    }

    try {
        // Use prefix before request the backend
        const server = "https://portalmanager.pro/api";
        const URL = server + route;

        const response = await axios.post(
            URL,
            { data: data },
            {
                timeout: REQUEST_TIMEOUT, // límite duro
            }
        );

        // Tu backend ya regresa el objeto { data, status, ... }
        return response.data;
    } catch (error) {
        // Catch errores V2 - Alert instead stop the App
        var customError = new Error("Error en la petición al backend");

        if (error && error.code === "ECONNABORTED") {
            customError.message = "La petición excedió el tiempo límite (timeout).";
            customError.code = "TIMEOUT";
        } else if (error && error.response) {
            customError.message = "Error " + error.response.status + " en el servidor.";
            customError.status = error.response.status;
        } else if (error && error.request) {
            customError.message = "No se pudo conectar con el servidor.";
            customError.code = "NETWORK";
        }

        console.log("getInformationWithData error:", customError.message);

        // showFriendlyError(customError);

        // IMPORTANTE: no truenes la app
        return {
            data: [],
            status: status.Fail,
            message: customError.message,
            code: customError.code || null,
            httpStatus: customError.status || null
        };
    }
};

// Make http requests V2 - Backendv1
export const getInformationWithDataB1 = async (route, data) => {
    // Validate session
    if (!getValueCookie('userName')) {
        // Remove cookies
        closeSession();

        // Redirect to login V2
        window.location.assign("/logout");

        // Importante: rechazamos la promesa para que el caller lo pueda manejar si quiere
        throw new Error('Invalid user session');
    }

    try {
        // Use prefix before request the backend
        const prefix = getValueCookie('apiPrefix');
        // const apiPrefix = prefix ? prefix : '';
        // const URL =  'baseURLAuth' + apiPrefix + route;
        const URL =  'https://apiportalmanager.mayaland.store' + route;
        // Get JWT
        const jwtToken = getValueCookie('sessionAuthToken');

        const response = await axios.post(
            URL,
            { data: data },
            {
                timeout: REQUEST_TIMEOUT,
                headers: {
                    Authorization: `Bearer: ${jwtToken}`
                }
            }
        );

        // Validar session
        if ("error" in response.data) {
            if (response.data.error === "INVALID_CREDENTIALS" || response.data.error === "TOKEN_INVALID_OR_EXPIRED") {
                Swal.fire({
                    title: `Invalid session or expired`,
                    text: "Please, login again.",
                    icon: 'warning',
                    confirmButtonColor: '#14398a',
                    cancelButtonColor: '#626262',
                    showCancelButton: true,
                    confirmButtonText: 'Yes, Login again.',
                    cancelButtonText: 'No, cancel.',
                }).then(async (result) => {
                    if (result.isConfirmed) {
                        window.location.assign("/logout");
                    }
                });

                return { status: { code: -1 }, data: [] };
            }

        }

        // Tu backend ya regresa el objeto { data, status, ... }
        return response.data;
    } catch (error) {
        // Catch errores V2 - Alert instead stop the App
        var customError = new Error("Error en la petición al backend");

        if (error && error.code === "ECONNABORTED") {
            customError.message = "La petición excedió el tiempo límite (timeout).";
            customError.code = "TIMEOUT";
        } else if (error && error.response) {
            customError.message = "Error " + error.response.status + " en el servidor.";
            customError.status = error.response.status;
        } else if (error && error.request) {
            customError.message = "No se pudo conectar con el servidor.";
            customError.code = "NETWORK";
        }

        console.log("getInformationWithData error:", customError.message);

        // showFriendlyError(customError);

        // IMPORTANTE: no truenes la app
        return {
            data: [],
            status: status.Fail,
            message: customError.message,
            code: customError.code || null,
            httpStatus: customError.status || null
        };
    }
};
export const getInformationWithData = async (route, data) => {
    // Validate session
    if (!getValueCookie('userName')) {
        // Remove cookies
        closeSession();

        // Redirect to login V2
        window.location.assign("/logout");

        // Importante: rechazamos la promesa para que el caller lo pueda manejar si quiere
        throw new Error('Invalid user session');
    }

    try {
        // Use prefix before request the backend
        const prefix = getValueCookie('apiPrefix');
        const apiPrefix = prefix ? prefix : '';
        const URL =  baseURLAuth + apiPrefix + route;
        // Get JWT
        const jwtToken = getValueCookie('sessionAuthToken');

        const response = await axios.post(
            URL,
            { data: data },
            {
                timeout: REQUEST_TIMEOUT,
                headers: {
                    Authorization: `Bearer: ${jwtToken}`
                }
            }
        );

        // Validar session
        if ("error" in response.data) {
            if (response.data.error === "INVALID_CREDENTIALS" || response.data.error === "TOKEN_INVALID_OR_EXPIRED") {
                Swal.fire({
                    title: `Invalid session or expired`,
                    text: "Please, login again.",
                    icon: 'warning',
                    confirmButtonColor: '#14398a',
                    cancelButtonColor: '#626262',
                    showCancelButton: true,
                    confirmButtonText: 'Yes, Login again.',
                    cancelButtonText: 'No, cancel.',
                }).then(async (result) => {
                    if (result.isConfirmed) {
                        window.location.assign("/logout");
                    }
                });

                return { status: { code: -1 }, data: [] };
            }

        }

        // Tu backend ya regresa el objeto { data, status, ... }
        return response.data;
    } catch (error) {
        // Catch errores V2 - Alert instead stop the App
        var customError = new Error("Error en la petición al backend");

        if (error && error.code === "ECONNABORTED") {
            customError.message = "La petición excedió el tiempo límite (timeout).";
            customError.code = "TIMEOUT";
        } else if (error && error.response) {
            customError.message = "Error " + error.response.status + " en el servidor.";
            customError.status = error.response.status;
        } else if (error && error.request) {
            customError.message = "No se pudo conectar con el servidor.";
            customError.code = "NETWORK";
        }

        console.log("getInformationWithData error:", customError.message);

        // Show a non-blocking toast — debounced so multiple parallel failures
        // only produce one notification.
        const isWorkerOffline = error && error.response && (
            error.response.status === 503 || error.response.status === 504 ||
            (error.response.data && (error.response.data.workerOffline || error.response.data.workerTimeout))
        );
        showWorkerToast(isWorkerOffline, customError.status || null, customError.code || null);

        // IMPORTANTE: no truenes la app
        return {
            data: [],
            status: status.Fail,
            message: customError.message,
            code: customError.code || null,
            httpStatus: customError.status || null,
            workerOffline: isWorkerOffline || false,
        };
    }
};


export const getDetailSO = async (route, data) => {
    // const prefix = getValueCookie('apiPrefix');
    // const apiPrefix = prefix ? prefix : '';
    // const URL =  baseURLAuth + apiPrefix + route;
    const URL = baseURLAuth + route
    var responseBack = {
        data: [],
        status: status.Fail
    }

    if (getValueCookie('userName')) {
        try {
            const response = await axios.post(URL, { data: data }, { timeout: 90000 })
            responseBack = response.data
        }
        catch (error) {
            if (error.code === 'ECONNABORTED') {
                console.error('Request timed out')
            } else {
                console.error('Request failed', error.message)
            }
        }
        // await axios.post(URL, { data: data }).then(
        //     response => {
        //         responseBack = response.data
        //     }
        // ).catch(error => {
        //     confirmCloseAlert('incorrect', 'Error in the Server Response: ' + error)
        // })
    } else {
        window.location.reload()
    }

    return responseBack
}

export const saveJsonData = async (route, data) => {
    const URL = baseURLAuth + route
    await axios.post(URL, { data }).then().catch(error => {
        // confirmCloseAlert('incorrect', 'Error in the Server Response: ' + error)
    })
}

export const create_Delete_Update_Information = async (route, data) => {
    // Validate session
    if (!getValueCookie('userName')) {
        // Remove cookies
        closeSession();

        // Redirect to login V2
        window.location.assign("/logout");

        // Importante: rechazamos la promesa para que el caller lo pueda manejar si quiere
        throw new Error('Invalid user session');
    }

    try {
        // Use prefix before request the backend
        const prefix = getValueCookie('apiPrefix');
        const apiPrefix = prefix ? prefix : '';
        const URL =  baseURLAuth + apiPrefix + route;
        // Get JWT
        const jwtToken = getValueCookie('sessionAuthToken');

        var responseBack = {
            data: [],
            status: status.Fail
        }

        await axios.post(
            URL,
            { data: data },
            {
                timeout: REQUEST_TIMEOUT,
                headers: {
                    Authorization: `Bearer: ${jwtToken}`
                }
            }
        ).then(
            response => {
                responseBack = response.data
            }
        ).catch(error => {
            // confirmCloseAlert('incorrect', 'Error in the Server Response: ' + error)
            console.log("create_Delete_Update_Information. Error: ", error);
        });

        return responseBack;

    } catch (error) {
        // Catch errores V2 - Alert instead stop the App
        var customError = new Error("Error en la petición al backend");

        if (error && error.code === "ECONNABORTED") {
            customError.message = "La petición excedió el tiempo límite (timeout).";
            customError.code = "TIMEOUT";
        } else if (error && error.response) {
            customError.message = "Error " + error.response.status + " en el servidor.";
            customError.status = error.response.status;
        } else if (error && error.request) {
            customError.message = "No se pudo conectar con el servidor.";
            customError.code = "NETWORK";
        }

        console.log("create_Delete_Update_Information error:", customError.message);

        const isWorkerOffline = error && error.response && (
            error.response.status === 503 || error.response.status === 504 ||
            (error.response.data && (error.response.data.workerOffline || error.response.data.workerTimeout))
        );
        showWorkerToast(isWorkerOffline, customError.status || null, customError.code || null);

        return {
            data: [],
            status: status.Fail,
            message: customError.message,
            code: customError.code || null,
            httpStatus: customError.status || null,
            workerOffline: isWorkerOffline || false,
        };
    }
}

export const uploadFile = async (route, file) => {
    const URL = baseURLAuth + route
    var responseBack = {
        data: [],
        status: status.Fail
    }

    if (getValueCookie('userName')) {
        await axios.post(URL, file, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }).then(
            response => {
                responseBack = response.data
            }
        ).catch(error => {
            // confirmCloseAlert('incorrect', 'Error in the Server Response: ' + error)
        })
    } else {
        window.location.reload()
    }


    return responseBack
}


export const getInformationWithDataGlobalSales = async (route, data) => {
    const URL = 'https://apiglobalsales.mayaland.store' + route  // PRODUCCION
    // const URL = 'http://localhost:3601' + route  // LOCAL
    var responseBack = {
        data: [],
        status: status.Fail
    }
    if (getValueCookie('userName')) {
        await axios.post(URL, data).then(
            response => {
                responseBack = response.data
            }
        ).catch(error => {
            // confirmCloseAlert('incorrect', 'Error in the Server Response: ' + error)
        })
    } else {
        window.location.reload()
    }

    return responseBack
}

// ── Dashboard V2 / LobbyV2 — URLs aisladas ───────────────────────────────────
// Cambia las URLs en dashboardConfig.js para pasar de local → subdominio v3.
// El resto de la app no se ve afectado.

export const getInformationWithDataDashboard = async (route, data) => {
    if (!getValueCookie('userName')) {
        closeSession();
        window.location.assign("/logout");
        throw new Error('Invalid user session');
    }
    try {
        const prefix = getValueCookie('apiPrefix');
        const apiPrefix = prefix ? prefix : '';
        const URL = dashboardConfig.portalManager + apiPrefix + route;
        const jwtToken = getValueCookie('sessionAuthToken');
        const response = await axios.post(URL, { data }, {
            timeout: REQUEST_TIMEOUT,
            headers: { Authorization: `Bearer: ${jwtToken}` }
        });
        if ("error" in response.data) {
            if (response.data.error === "INVALID_CREDENTIALS" || response.data.error === "TOKEN_INVALID_OR_EXPIRED") {
                window.location.assign("/logout");
                return { status: { code: -1 }, data: [] };
            }
        }
        return response.data;
    } catch (error) {
        const customError = new Error("Error en la petición al dashboard backend");
        if (error && error.code === "ECONNABORTED") { customError.code = "TIMEOUT"; }
        else if (error && error.request)             { customError.code = "NETWORK"; }
        console.log("getInformationWithDataDashboard error:", error && error.message);
        return { data: [], status: status.Fail, code: customError.code || null };
    }
};

// ── v3 protocol (2026-08-05) — URL aislada, NO comparte config con el dashboard ──
// Cambia la URL en v3Config.js. dashboardConfig.js (arriba) es de Dashboard V2/LobbyV2
// y no debe tocarse por esto ni viceversa — son dos canales completamente independientes.

export const getInformationWithDataV3 = async (route, data) => {
    if (!getValueCookie('userName')) {
        closeSession();
        window.location.assign("/logout");
        throw new Error('Invalid user session');
    }
    try {
        const prefix = getValueCookie('apiPrefix');
        const apiPrefix = prefix ? prefix : '';
        const URL = v3Config.portalManagerV3 + apiPrefix + route;
        const jwtToken = getValueCookie('sessionAuthToken');
        const response = await axios.post(URL, { data }, {
            timeout: REQUEST_TIMEOUT,
            headers: { Authorization: `Bearer: ${jwtToken}` }
        });
        if ("error" in response.data) {
            if (response.data.error === "INVALID_CREDENTIALS" || response.data.error === "TOKEN_INVALID_OR_EXPIRED") {
                window.location.assign("/logout");
                return { status: { code: -1 }, data: [] };
            }
        }
        return response.data;
    } catch (error) {
        const customError = new Error("Error en la petición al backend v3");
        if (error && error.code === "ECONNABORTED") { customError.code = "TIMEOUT"; }
        else if (error && error.request)             { customError.code = "NETWORK"; }
        console.log("getInformationWithDataV3 error:", error && error.message);
        return { data: [], status: status.Fail, code: customError.code || null };
    }
};

export const getInformationWithDataGlobalSalesDashboard = async (route, data) => {
    const URL = dashboardConfig.globalSales + route;
    var responseBack = { data: [], status: status.Fail };
    if (getValueCookie('userName')) {
        await axios.post(URL, data).then(
            response => { responseBack = response.data; }
        ).catch(() => {});
    } else {
        window.location.reload();
    }
    return responseBack;
};

export default { getInformationNoData, create_Delete_Update_Information, getInformationWithData, getInformationWithDataGlobalSales }

